import * as React from 'react';
import { useEffect, useState } from 'react';
import {  useRouteMatch } from 'react-router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Footer } from '../Components/Footer/Footer';
import { VideoDetails } from '../Components/VideoDetails/VideoDetails';

import { VideoPlayer } from '../Components/VideoPlayer/VideoPlayer';
import { Database } from '../Managers/DataManager';
import VideoManager from '../Managers/VideoManager';
import { VideoModel } from '../Models/Video.interface';
var dayjs = require('dayjs')



export const Watch = () => {
    const location = useRouteMatch()

    const program_name= location.params?.['program_name'] 
    const episode_name = location?.params?.['episode_name']

    const uuid = location?.params?.['uuid']

    const video_id = location?.params?.['video_id']


    const [ video, setVideo] = useState<VideoModel | null>()

    const leaving = new Subject<void>()
    useEffect(() => {
        if(!program_name || !episode_name) { return }
        Database.get(`/watch/${program_name}/${episode_name}`)
        .then(sub => {
            sub.pipe(takeUntil(leaving))
            .subscribe(setVideo)
        })
        .catch(console.error)

        return () => leaving.next()
    }, [program_name, episode_name])

    useEffect(() => {
        if(!uuid) { return }
        Database.get(`/uuid/${uuid}`)
        .then(sub => {
            sub.pipe(takeUntil(leaving))
            .subscribe(setVideo)
        })
        .catch(console.error)

        return () => leaving.next()
    }, [uuid])

    useEffect(() => {
        if(video){
            console.log(video)
            VideoManager.setVideo(video)
        }
        
    }, [video])
    return(
        <div style={{
            // height: '300vh',
            paddingTop: 100,
            backgroundColor: '#04060a'
        }}>
            <VideoPlayer />
           <VideoDetails video={video}/>
            <Footer />


        </div>
    )
}

